import { render } from "./SchemaSolutionMarkup.vue?vue&type=template&id=82544d2e&scoped=true"
import script from "./SchemaSolutionMarkup.vue?vue&type=script&lang=js"
export * from "./SchemaSolutionMarkup.vue?vue&type=script&lang=js"

import "./SchemaSolutionMarkup.vue?vue&type=style&index=0&id=82544d2e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82544d2e"]])

export default __exports__